<script setup>
  function ehPaginaRespondente() {
    return window.location.href.indexOf('responder') >= 0
  }

  function ehAmbienteHomologacao() {
    let ehLocalHost = window.location.href.indexOf('localhost') >= 0
    let ehHomologacao = window.location.href.indexOf('homologacao.questnova.com.br') >= 0
    return ehLocalHost || ehHomologacao
  }

  //cria um estado reativo para a chave da nossa página
  const controleAtualizacaoPagina = useState('controleAtualizacaoPagina', () => 1)
</script>

<template>
  <div>
    <el-alert type="warning" effect="dark" class2="fundo-marca-azul" v-if="ehAmbienteHomologacao()">
      Atenção! Este é um ambiente de Testes / Homologação.
    </el-alert>
    
    <menu-sistema/>

    <div class="borda-interior-aplicacao" :key="controleAtualizacaoPagina">
      <slot/>
    </div>

    <div class="rodape-fixo-apoio" v-if="!utilLogin.estaLogado() && !ehPaginaRespondente()">
      <table border="0px" cellpadding="0" cellspacing="0" class="rodape-fixo-apoio-interior">
        <tbody>
          <tr>
            <td>
              <b style="font-size: small">Apoio:</b>
            </td>
          </tr>
          <tr>
            <td>
              <img src="/apoio/nupens.png" style="width: 50px">
            </td>
            <td style="padding-left: 10px">
              <img src="/apoio/usp.png" style="width: 50px">
            </td>
            <td style="padding-left: 10px">
              <img src="/apoio/fsp.png" style="width: 50px">
            </td>
            <td style="padding-left: 10px">
              <img src="/apoio/fapesp.png" style="width: 50px"><br>
              <i style="font-size: 10px">Processo n°2021/10993-3</i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="rodape-fixo-softjads">
      <div style="padding-top: 7px">
        <a href="https://softjads.com.br" style="color: gray; text-decoration: none;" target="_blank">SOFTJADS - Desenvolvimento de Sistemas</a>
      </div>
    </div>
    <br>
  </div>
</template>

<style scoped>
.borda-interior-aplicacao {
  padding: 10px;
  padding-top: 10px;
}
.rodape-fixo-softjads {
    position: fixed; 
    bottom: 0;
    left: 0;
    right: 0;
    height: 28px;
    font-size: x-small;
    background-color: #efefef;
    color: gray;
    text-align: center
}
.rodape-fixo-apoio {
    position: fixed; 
    bottom: 29px;
    left: 0px;
    right: 0px;
    height: 96px;
    background-color: white;
    color: black;
    text-align: left;
    width: 100%;
}
.rodape-fixo-apoio-interior {
    position: fixed; 
    bottom: 21px;
    right: 0px;
    height: 70px;
    background-color: white;
    color: black;
    text-align: left;
    margin: 10px;
    width: 340px;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #efefef;
}
</style>